import React, {Fragment} from 'react';
import {FormField, Popup} from 'components';
import {get, shorten, camelCase, useField, useFocusPopup, useNamedSelector} from 'helpers';
import css from './goals-dropdown.module.scss';

export function GoalsDropdown(props) {
  const [ { value }, , { setValue } ] = useField(props);
  const popup = useFocusPopup(Goals, {
    ...props,
    value,
    setValue,
    className: 'adjacent'
  });
  const { goal, parentGoal } = useNamedSelector('goals.details', { id: value });
  const goals = useNamedSelector('goals.inProgress');
  const label = [
    get(parentGoal, 'name'),
    get(goal, 'name'),
  ].map(name => shorten(name, { chars: 30 })).filter(Boolean).join(' → ');

  return goals.length > 0 && (
    <FormField label="Link to Goal" value={value} {...popup} clear={() => setValue(null)}>
      <b>{ label }</b>
    </FormField>
  );
}

function Goals({ popup, value, setValue }) {
  return (
    <Popup.Menu>
      { useNamedSelector('goals.inProgress').map(goal =>
        <Goal key={goal.id} {...goal} popup={popup} value={value} setValue={setValue} />
      ) }
    </Popup.Menu>
  );
}

function Goal({ id, name, value, setValue }) {
  const { category, milestones = [] } = useNamedSelector('goals.details', { id });
  return (
    <Fragment>
      <Popup.Menu.Item onClick={() => setValue(id)} pressed={value == id} background={css[camelCase(category)]}>
        { shorten(name, { words: 10 }) }
      </Popup.Menu.Item>
      { milestones.map(milestone =>
        <Popup.Menu.Item icon="enter" onClick={() => setValue(milestone.id)} pressed={value == milestone.id} key={milestone.id} className={css.milestone}>
          { shorten(milestone.name, { words: 10 }) }
        </Popup.Menu.Item>
      ) }
    </Fragment>
  );
}
